import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SkippedEmailReview } from '../components/gmail/SkippedEmailReview';
import { Button } from '../components/ui/Button';
import styles from './SkippedEmailsPage.module.css';

const SkippedEmailsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <header className={`${styles.header} mobile-page-header-anchor`}>
        <div className={styles.headerCopy}>
          <p className={styles.eyebrow}>Gmail</p>
          <h1 className={styles.title}>Skipped email review</h1>
          <p className={styles.description}>
            Inspect emails the triage layer skipped before deep analysis, then decide whether to
            re-run analysis or clear them from the queue.
          </p>
        </div>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => navigate('/settings/gmail')}
        >
          Back to settings
        </Button>
      </header>

      <SkippedEmailReview
        title="Review queue"
        description="Open the original email in Gmail, inspect the triage decision, and override it when needed."
      />
    </div>
  );
};

export default SkippedEmailsPage;
